export default "__VITE_ASSET__Cr3JNnzk__"